import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { getTextFromInfo } from '../../utils'

export default function PaymentAndCancellation({ paymentInformation, milestones, isCustomCancellation, cancellationMilestones, customCancellationText, currency }) {
  function getMilestoneAmountType(amountTypeKey) {
    return getTextFromInfo(amountTypeKey, 'shop', 'MILESTONE_AMOUNT_TYPE') || currency
  }

  return (
    <Fragment>
      <div className='circled-list'>
        <ul>
          <li className='title'><FormattedMessage id='payment_schedule' defaultMessage='Payment schedule' /></li>
          <li className='bold'><FormattedMessage id='now_0' defaultMessage='Now: 0%' /></li>
          <li>
            <FormattedMessage id='payment_schedule.due_booking' values={{ amount: paymentInformation.paymentTerms, amountType: getMilestoneAmountType(paymentInformation.paymentTermsType) }} defaultMessage='48 hours after booking confirmation: { amount }{ amountType } (downpayment)' />
          </li>
          { milestones.map((milestone, index) => {
            return (<li key={milestone.id}>
              { index + 1 !== milestones.length ? (
                <FormattedMessage id='milestone_amount_first'
                  values={{
                    amount: milestone.amount,
                    amountType: getMilestoneAmountType(milestone.kind),
                    days: milestone.days,
                  }}
                  defaultMessage='{ days } days before trip start: { amount }{ amountType }' />
              ) : (
                <FormattedMessage id='milestone_amount_last'
                  values={{
                    amount: milestone.amount,
                    amountType: getMilestoneAmountType(milestone.kind),
                    days: milestone.days,
                  }}
                  defaultMessage='{ days } days before trip start: { amount }{ amountType } (balance)' />
              )}
            </li>)
          })
          }
        </ul>
      </div>
      { cancellationMilestones
        ? (<div className='circled-list'>
          <ul className='circled-list pbn'>
            <li className='title'><FormattedMessage id='cancellation_fees' defaultMessage='Cancellation fees' /></li>
          </ul>
          {
            isCustomCancellation
              ? (<div className='wysiwyg' dangerouslySetInnerHTML={{ __html: customCancellationText }} />)
              : ''
          }
        </div>) : ''
      }
      { !isCustomCancellation ? (
        <div className='circled-list'>
          { cancellationMilestones.length > 2
            ? (<ul>
              <li><FormattedMessage id='cancellation.free_text' defaultMessage='Free cancellation for 48h after confirmation (except for last minute bookings)' /></li>
              { cancellationMilestones.map((milestone, index) => {
                return (<li key={milestone.id}>
                  { index === 0 ? (
                    <FormattedMessage
                      id='cancel_milestone_first'
                      values={{
                        amount: milestone.amount,
                        days: milestone.days,
                      }} defaultMessage='{ amount }% of the total booking amount will be charged if you cancel more than { days } days prior to arrival' />
                  ) : ''}
                  { index !== 0 && index + 1 !== cancellationMilestones.length ? (
                    <FormattedMessage id='cancel_milestone2' values={{
                      amount: milestone.amount,
                      prevDays: cancellationMilestones[index - 1].days,
                      days: milestone.days,
                    }} defaultMessage='{ amount }% will be charged if you cancel between { prevDays } and { days } days prior to arrival' />
                  ) : '' }
                  {
                    index + 1 === cancellationMilestones.length ? (
                      <FormattedMessage id='cancel_milestone_last'
                        values={{
                          amount: milestone.amount,
                          days: milestone.days,
                        }} defaultMessage='{ amount }% will be charged if you cancel less than { days } days prior to arrival' />
                    ) : ''
                  }
                </li>)
              }) }
            </ul>) : ''
          }
          {
            cancellationMilestones.length === 2 ? (
              <ul>
                <li>
                  <FormattedMessage id='cancellation.free_text' defaultMessage='Free cancellation for 48h after confirmation (except for last minute bookings) ' />
                </li>
                <li>
                  <FormattedMessage id='cancel_milestone_first'
                    values={{
                      amount: cancellationMilestones[0].amount,
                      days: cancellationMilestones[0].days,
                    }} defaultMessage='{ amount }% of the total booking amount will be charged if you cancel more than { days } days prior to arrival' />
                </li>
                <li>
                  <FormattedMessage id='cancel_milestone_last'
                    values={{
                      amount: cancellationMilestones[1].amount,
                      days: cancellationMilestones[1].days,
                    }} defaultMessage='{ amount }% will be charged if you cancel less than { days } days prior to arrival' />
                </li>
              </ul>
            ) : ''
          }{
            cancellationMilestones.length === 1 ? (
              <ul>
                <li><FormattedMessage id='cancellation.free_text' defaultMessage='Free cancellation for 48h after confirmation (except for last minute bookings)' /></li>
                <li>
                  <FormattedMessage id='cancel_milestone_last'
                    values={{
                      amount: cancellationMilestones[0].amount,
                      days: cancellationMilestones[0].days,
                    }} defaultMessage='{ amount }% will be charged if you cancel less than { days } days prior to arrival' />
                </li>
              </ul>
            ) : ''
          }
        </div>
      ) : ''}
    </Fragment>
  )
}
